<template>
  <div class="redirect-wrap">
    <div class="redirect-txt">登录中...</div>
  </div>
</template>

<script>
import { getQueryString } from '@/utils/common'
import { getOauth } from '@/api/admin'
import { storage } from '@/utils/storage'

function upsertQuery (qs, key, val) {
  const parts = (qs || '').split('&').filter(Boolean).filter(p => p.split('=')[0] !== key)
  parts.push(key + '=' + val)
  return parts.join('&')
}

function setUrlParam (url, key, value) {
  const val = encodeURIComponent(value || '')
  const hashIdx = url.indexOf('#')
  if (hashIdx >= 0) {
    const pre = url.slice(0, hashIdx)
    const hash = url.slice(hashIdx)
    const qIdx = hash.indexOf('?')
    if (qIdx >= 0) {
      const hp = hash.slice(0, qIdx)
      const qs = hash.slice(qIdx + 1)
      return pre + hp + '?' + upsertQuery(qs, key, val)
    }
    return pre + hash + (hash.includes('?') ? '&' : '?') + key + '=' + val
  }
  const qIdx = url.indexOf('?')
  if (qIdx >= 0) {
    const base = url.slice(0, qIdx)
    const qs = url.slice(qIdx + 1)
    return base + '?' + upsertQuery(qs, key, val)
  }
  return url + '?' + key + '=' + val
}

export default {
  name: 'Redirect',
  async mounted () {
    const q = (this.$route && this.$route.query) || {}
    const code = q.code || getQueryString('code')
    const state = q.state || getQueryString('state')
    const svapid = q.svapid || getQueryString('svapid') || storage.get('author_wx_appid')

    const cachedState = storage.get('author_wx_state')
    if (cachedState && state && cachedState !== state) {
      this.$createToast({ type: 'warn', time: 1200, txt: '非法回调' }).show()
      return
    }

    if (!code) {
      this.$createToast({ type: 'warn', time: 1200, txt: '缺少参数：code' }).show()
      return
    }
    if (!svapid) {
      this.$createToast({ type: 'warn', time: 1200, txt: '缺少参数：svapid' }).show()
      return
    }

    const redirectUrl =
      q.redirectUrl ||
      getQueryString('redirectUrl') ||
      storage.get('author_redirect_url') ||
      '/'

    const loading = this.$createToast({ type: 'loading', time: 0, txt: '登录中...' })
    loading.show()
    try {
      const res = await getOauth({ code, svapid })
      const loginVo = (res && res.data) ? res.data : (res || {})
      const token = loginVo.token
      if (!token) {
        this.$createToast({ type: 'warn', time: 1200, txt: '后端未返回token' }).show()
        return
      }

      // 兼容旧逻辑：request.js 从 localStorage.token 读取
      storage.set('token', token)


      // state 用完即清
      storage.remove('author_wx_state')

      const nextUrl = setUrlParam(redirectUrl, 'token', token)
      window.location.replace(nextUrl)
    } catch (e) {
      this.$createToast({ type: 'warn', time: 1200, txt: '登录失败' }).show()
    } finally {
      loading.hide()
    }
  }
}
</script>

<style scoped>
.redirect-wrap {
  padding-top: 0.8rem;
  text-align: center;
}
.redirect-txt {
  color: #666;
  font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/components/redirect.vue